const REQUIRED = ["REACT_APP_BASE_URL"]

// REACT_APP_PUBLIC_SITE_URL: the PROD site encoded in event QR codes, so a QR
// downloaded from a staging admin still points attendees at PROD. Falls back
// to the current origin when unset.
const OPTIONAL = [
  "REACT_APP_TECHNICIAN_PORTAL_URL",
  "REACT_APP_PUBLIC_SITE_URL",
]

const read = (key) => {
  const value = process.env[key]
  return typeof value === "string" ? value.trim() : ""
}

const resolved = {}

for (const key of REQUIRED) {
  const value = read(key)
  if (!value) {
    throw new Error(`Missing required environment variable: ${key}`)
  }
  resolved[key] = value
}

for (const key of OPTIONAL) {
  const value = read(key)
  if (!value && process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.warn(`Optional environment variable not set: ${key}`)
  }
  resolved[key] = value
}

export const env = Object.freeze(resolved)
